export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_TRACKING_ID;

/**
 * Sends a page view notification to google analytics
 * @param url the url of the viewed page
 * @see https://developers.google.com/analytics/devguides/collection/gtagjs/pages
 */
export const pageview = (url: string): void => {
  window.gtag && window.gtag('config', GA_TRACKING_ID, {
    page_path: url,
  });
};

/**
 * Sends Google analytics events
 * @param param event params
 * @see https://developers.google.com/analytics/devguides/collection/gtagjs/events
 */
export const event = ({ action, category, label, value }: { action: string; category: string; label: string; value: string}): void => {
  window.gtag && window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
  });
};
